(function () {
  const $ = (id) => document.getElementById(id);

  (function sticky() {
    const bar = $("stickycta");
    const hero = document.querySelector(".hero");
    const join = $("join");
    if (!bar || !hero || !join || !("IntersectionObserver" in window)) return;
    let heroVis = true;
    let joinVis = false;
    const upd = () => bar.classList.toggle("on", !heroVis && !joinVis);
    new IntersectionObserver((entries) => {
      heroVis = entries[0].isIntersecting;
      upd();
    }).observe(hero);
    new IntersectionObserver((entries) => {
      joinVis = entries[0].isIntersecting;
      upd();
    }, { threshold: 0.05 }).observe(join);
  })();

  const thanks = $("thanks");
  if (thanks) {
    thanks.scrollIntoView({ block: "center" });
    thanks.focus({ preventScroll: true });
  }

  (function box3d() {
    const box = $("box");
    const stage = $("stage");
    if (!box || !stage) return;
    const loadFaces = () => {
      box.querySelectorAll("[data-bg]").forEach((el) => {
        el.style.background = "url(" + el.dataset.bg + ") center/100% 100%";
      });
    };
    if (document.readyState === "complete") loadFaces();
    else window.addEventListener("load", loadFaces);
    let rx = -8;
    let ry = -28;
    let drag = false;
    let sx = 0;
    let sy = 0;
    let bx = 0;
    let by = 0;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function apply() {
      box.style.transform = "rotateX(" + rx + "deg) rotateY(" + ry + "deg)";
    }
    stage.addEventListener("pointerdown", (e) => {
      drag = true;
      sx = e.clientX;
      sy = e.clientY;
      bx = ry;
      by = rx;
      stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener("pointermove", (e) => {
      if (!drag) return;
      ry = bx - (e.clientX - sx) * 0.5;
      rx = Math.max(-35, Math.min(25, by - (e.clientY - sy) * 0.3));
      apply();
    });
    ["pointerup", "pointercancel"].forEach((type) => {
      stage.addEventListener(type, () => {
        drag = false;
      });
    });
    if (!reduce) {
      const start = () => {
        const t0 = performance.now();
        (function sway(t) {
          if (!drag && t - t0 < 6000) {
            ry = -28 + Math.sin((t - t0) / 900) * 10;
            apply();
          }
          if (t - t0 < 6000) requestAnimationFrame(sway);
        })(t0);
      };
      if ("IntersectionObserver" in window) {
        const io = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          start();
        }, { rootMargin: "160px" });
        io.observe(stage);
      } else start();
    }
  })();

  (function easySellShippingFee() {
    const FEE = 6;
    const getStore = () => {
      const form = document.querySelector("#es-form");
      return form && form.__vue__ && form.__vue__.$store;
    };
    let applying = false;
    const apply = (store) => {
      if (!store || applying) return;
      const ship = store.state && store.state.shipping;
      if (!ship || !ship.config || ship.config.enabled === false) return;
      const cur = ship.selectedOption || (ship.options && ship.options[0]) || (ship.config.customRates && ship.config.customRates[0]);
      if (!cur) return;
      if (Number(cur.price) === FEE && ship.options && ship.options[0] && Number(ship.options[0].price) === FEE) return;
      const opt = Object.assign({}, cur, { type: "price", price: FEE, name: cur.name || "التوصيل" });
      const rates = (ship.config.customRates || [opt]).map((r) => Object.assign({}, r, { type: "price", price: FEE }));
      applying = true;
      try {
        store.commit("shipping/SET_SHIPPING_CONFIG", Object.assign({}, ship.config, { type: "custom", enabled: true, customRates: rates }));
        store.commit("shipping/SET_OPTIONS", rates);
        store.commit("shipping/SET_SELECTED_OPTION", opt);
      } finally {
        applying = false;
      }
    };
    let tries = 0;
    const boot = setInterval(() => {
      tries += 1;
      const store = getStore();
      if (!store) {
        if (tries > 80) clearInterval(boot);
        return;
      }
      clearInterval(boot);
      apply(store);
      store.subscribe((mutation) => {
        if (String(mutation.type).indexOf("shipping/") === 0) apply(store);
      });
    }, 250);
  })();

  (function quantityPicker() {
    const root = document.querySelector("[data-fikro-qty]");
    if (!root) return;
    const input = root.querySelector("[data-fikro-qty-input]");
    const buttons = [...root.querySelectorAll("[data-qty]")];
    if (!input || !buttons.length) return;
    const allowed = new Set(["1", "2", "3", "4", "5"]);

    const getStore = () => {
      const form = document.querySelector("#es-form");
      return form && form.__vue__ && form.__vue__.$store;
    };

    const syncCart = () => {
      const store = getStore();
      if (!store || typeof store.dispatch !== "function") return false;
      Promise.resolve(store.dispatch("cart/addVariantToCart")).catch(() => {});
      return true;
    };

    const setQty = (raw) => {
      const qty = allowed.has(String(raw)) ? String(raw) : "1";
      input.value = qty;
      buttons.forEach((btn) => {
        const on = btn.getAttribute("data-qty") === qty;
        btn.classList.toggle("is-on", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
      if (!syncCart()) {
        let tries = 0;
        const timer = setInterval(() => {
          tries += 1;
          if (syncCart() || tries > 40) clearInterval(timer);
        }, 250);
      }
    };

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => setQty(btn.getAttribute("data-qty")));
    });

  })();
})();
